const logStyles = {
    verbose: 'color: #78909C;',
    log: 'color: #F57F17;',
    debug: 'color: #03A9F4;',
    warn: 'background: #FFEB3B; color: #000000;',
    error: 'background: #F44336; color: #FFFFFF;',
    success: 'background: #43A047; color: #FFFFFF;'
};
/*eslint no-console: ["error", { allow: ["log","debug","success","warn", "error"] }]*/
export default {
    verbose: function log(key) {
        if (!__DEV__) return false;
        return console.log(`%c${key}`, logStyles.verbose);
    },
    log: function log(key, value = undefined) {
        if (!__DEV__) return false;
        if (typeof key === 'string' && value) return console.log(`%c${key}`, logStyles.log, value);
        if (typeof key === 'string') return console.log(`%c${key}`, logStyles.log);
        if (value) return console.log(key, value);
        return console.log(key);
    },
    debug: function debug(key, value = undefined) {
        if (!__DEV__) return false;
        if (typeof key === 'string' && value) return console.debug(`%c${key}`, logStyles.debug, value);
        if (typeof key === 'string') return console.debug(`%c${key}`, logStyles.debug);
        if (value) return console.debug(key, value);
        return console.debug(key);
    },
    warn: function warn(key, value = undefined) {
        if (!__DEV__) return false;
        if (typeof key === 'string' && value) return console.warn(`%c${key}`, logStyles.warn, value);
        if (typeof key === 'string') return console.warn(`%c${key}`, logStyles.warn);
        if (value) return console.warn(key, value);
        return console.warn(key);
    },
    error: function error(key, value = undefined) {
        // if (!__DEV__) return false;
        if (typeof key === 'string' && value) return console.error(`%c${key}`, logStyles.error, value);
        if (typeof key === 'string') return console.error(`%c${key}`, logStyles.error);
        if (value) return console.error(key, value);
        return console.error(key);
    },
    success: function success(key, value = undefined) {
        if (!__DEV__) return false;
        if (typeof key === 'string' && value) return console.log(`%c${key}`, logStyles.success, value);
        if (typeof key === 'string') return console.log(`%c${key}`, logStyles.success);
        if (value) return console.log(key, value);
        return console.log(key);
    }
};



// WEBPACK FOOTER //
// ./data/common/Logger.js